import { Text } from "@findemdev/maui";
import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: ${({ theme }) => theme.dimensions.spacing['4']};
  min-height: 0;
  overflow: hidden;
  padding: ${({ theme }) => theme.dimensions.spacing['5']};
`;

export const GridContent = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-content: start;
  gap: 20px;
`;

export const GridItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.dimensions.spacing['1']};
  cursor: pointer;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 46vh;
`;

export const FooterSection = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
`;

export const Detail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const EmptyState = styled(Text)`
  text-align: center;
`;
